import classNames from 'classnames';
import React from 'react';
import { useGlobalNavContext } from '../../state';
import { Logo, SearchBar } from '../common';
import { NavItemList } from './components';
import navStyles from './DesktopNav.module.scss';

export const DesktopNav = () => {
    const { navigation, env, positionSticky } = useGlobalNavContext();
    const { desktop } = navigation ?? {};
    const mainClass = positionSticky?.desktop
        ? classNames(navStyles.main, 'desktopSticky')
        : navStyles.main;

    return (
        <nav data-testid="desktop-nav" className={mainClass}>
            <ul className={navStyles.list}>
                {/* Logo */}
                <li className={navStyles.logo} tabIndex={-1}>
                    <Logo />
                </li>

                {/* Search */}
                <li className={navStyles.searchBar}>
                    <SearchBar />
                </li>

                {/* Nav Items */}
                <li className={navStyles.items}>
                    <NavItemList
                        navItems={desktop}
                        serverUrl={env?.serverUrl ?? ''}
                        signinUrl={env?.signinUrl ?? ''}
                        signupUrl={env?.signupUrl ?? ''}
                    />
                </li>
            </ul>
        </nav>
    );
};

export default DesktopNav;
